// main.js
import { createApp } from "vue"; // 引入 Vue 主框架
import App from "./App.vue"; // 引入主組件
import router from "./router"; // ✅ 引入 router 設定檔
import { createHead } from "@vueuse/head"; // ← 新增

const app = createApp(App); // 建立 Vue 應用實例
const head = createHead(); // ← 新增
app.use(head); // ← 新增
app.use(router); // ✅ 註冊 Vue Router
app.mount("#app"); // 掛載到 index.html 的 #app
